import styled from "@emotion/styled";

const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 48px;

  @media (max-width: 375px) {
    margin-top: 24px;
  }
`;

export const AuthFormTitle = styled.p`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  text-align: center;
`;

export const AuthFormParagraph = styled.p<{ textAlign?: "start" | "center" | "end" }>`
  font-size: 16px;
  margin: 0;
  text-align: ${(props) => props.textAlign ?? "center"};
`;

export default AuthForm;
